exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".question-title[data-v-1cc84b98]{font-size:20px;font-weight:700}.wrong-answer[data-v-1cc84b98]{color:red}.right-answer[data-v-1cc84b98]{color:green}", ""]);

// exports
